// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/videogular-themes-default/videogular.css
// module id = ./node_modules/videogular-themes-default/videogular.css
// module chunks = 1